module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-muted count"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": _vm.url,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.url))]), _vm._v("\n         \n        "), _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handleShareSurvey
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt"
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(!_vm.questionCharts.length) ? _c('div', {
    staticClass: "col-lg-9"
  }, [_c('div', {
    staticClass: "empty"
  }, [_vm._v("No entries received for this spot survey yet, charts will display once we've received more data.")])]) : _vm._e(), _vm._v(" "), (_vm.questionCharts.length) ? _c('div', {
    staticClass: "col-lg-9"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.questionCharts), function(question) {
    return _c('div', {
      key: question.question,
      class: ("col-lg-" + (6 / _vm.questionCharts.length))
    }, [_c('h4', {
      staticClass: "chart-title"
    }, [_vm._v(_vm._s(question.question))]), _vm._v(" "), _c('bar-chart', {
      attrs: {
        "height": 350,
        "showYAxes": true,
        "showXAxes": false,
        "colorCycle": _vm.generateColorPool(question.answers, _vm.hue),
        "data": _vm.totalDisplay(question.answers),
        "options": _vm.chartOptions,
        "autoSkipX": false,
        "maxXRotation": 90
      },
      on: {
        "onClick": function($event) {
          return _vm.handleChartClicked($event, question)
        }
      }
    }), _vm._v(" "), _c('chart-legend', {
      attrs: {
        "colorCycle": _vm.generateColorPool(question.answers, _vm.hue),
        "data": _vm.totalDisplay(question.answers),
        "isPercentage": _vm.totalDisplayOption === 'percentage'
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, _vm._l((_vm.profileRowCount), function(i) {
    return _c('div', {
      key: i,
      staticClass: "row"
    }, _vm._l((_vm.profileKeysForRow(i)), function(key) {
      return _c('div', {
        key: key,
        staticClass: "col-lg-6 text-center"
      }, [_c('div', {
        staticClass: "v-chart-block"
      }, [_c('spot-profile-chart', {
        attrs: {
          "field": key,
          "hue-range": _vm.hue,
          "chartData": _vm.profileCharts[key],
          "totalDisplayOption": _vm.totalDisplayOption
        },
        on: {
          "onRequestRespondents": _vm.handleRequestRespondents
        }
      })], 1)])
    }), 0)
  }), 0)], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('h4', [_vm._v("Total entries received")]), _vm._v(" "), _c('div', {
    staticClass: "entries"
  }, [_vm._v(_vm._s(_vm.entries.toLocaleString()))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Daily entry rate")]), _vm._v(" "), _c('div', {
    staticClass: "chart"
  }, [_c('trend', {
    attrs: {
      "points": _vm.entryChart,
      "height": 50
    }
  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Duration progress")]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    style: ({
      width: (_vm.progress + "%")
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "date-range"
  }, [_c('p', [_vm._v("\n            Survey is\n            "), _c('strong', [_vm._v(_vm._s(_vm.progress) + "%")]), _vm._v(" complete.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            Running from\n            "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.startDate, 'MMM Do YYYY')))]), _vm._v(" to\n            "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.endDate, 'MMM Do YYYY')))])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bfe84ed","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveys/SpotItem.vue
// module id = 3162
// module chunks = 3